// Home-level wound report — pressure-ulcer incidence and prevalence for one
// location, month by month. Read-only: the report is a projection over the
// resident's wounds (observation_subjects), so there is nothing to write here.
// A wound is RECORDED as an observation, never typed into a report.

export const FETCH_WOUND_REPORT = "app/WOUND_REPORT/FETCH_WOUND_REPORT";
export const FETCH_WOUND_REPORT_SUCCESS =
  "app/WOUND_REPORT/FETCH_WOUND_REPORT_SUCCESS";
export const FETCH_WOUND_REPORT_FAILURE =
  "app/WOUND_REPORT/FETCH_WOUND_REPORT_FAILURE";
